import { map } from 'lodash';

import { type OptionType } from '@hivebrite/design-system/Inputs';

import { type OptionInput } from '../types';

export const getOptions = (input?: Array<OptionInput>): Array<OptionType> =>
  map(input, ({ id, name }) => ({ label: name, value: id }));
